import {get} from 'lodash-es';
export default class HelpTranslationService {
  constructor($q, $http, $rootScope, appSettings) {
    'ngInject';
    this.$q = $q;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.translation = {};
    this.showMissingTag = appSettings.environment === appSettings.environments.local;
  }
  getUserLanguage() {
    return get(this.$rootScope, 'currentUser.claims.data.language', 'en');
  }
  loadHelpTranslation() {
    const userLanguage = this.getUserLanguage();
    if (userLanguage === 'en') {
      return this.$q(resolve => resolve()).then(() => {
        this.translation = {};
      });
    }
    const path = `content/help/${userLanguage}.json`;
    return this.$http.get(path).then(res => {
      this.translation = res.data;
      return res.data;
    });
  }
}
